import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { Checkbox } from 'ui-components/components/checkbox';
import LabeledRow from '../../../fulfillment-planner/labeled-row';
import PackageDropdownContainer from '../../../fulfillment-planner/package/dropdown/container';
import MultiPackage from '../../../fulfillment-planner/package/multi-package';
import DimensionsContainer from '../../../fulfillment-planner/dimensions/container';
import {
  PackageContentDescriptionInput,
  PackageContentDescriptionLabel,
  PackageContentDescriptionInfoIcon,
  useShouldRequirePackageContentDescription,
} from '../../../fulfillment-planner/package-content-description';
import { ScanToPrintWeight } from './weight';
import messages from '../../../fulfillment-planner/labeled-row/messages';

import style from './style.module.less';

export const PackagePlanner = ({ fulfillmentPlanId }) => {
  const [useScale, setUseScale] = useState(true);

  const onToggleScale = useCallback(() => setUseScale((shouldUseScale) => !shouldUseScale), []);

  const showPackageContentDescription = useShouldRequirePackageContentDescription();

  return (
    <div className={style.planner}>
      <div className={style['title-and-scale-toggle']}>
        <div className={style['create-label']}>
          <FormattedMessage {...messages.createLabel} />
        </div>
        <Checkbox checked={useScale} label={<FormattedMessage {...messages.useScale} />} largeCheckbox onChange={onToggleScale} />
      </div>
      <div className={style['package-info']}>
        <ScanToPrintWeight fulfillmentPlanId={fulfillmentPlanId} shouldUseScale={useScale} />
        <div className={style['package-and-size']}>
          <LabeledRow label={<FormattedMessage {...messages.package} />} labelClassName={style.label}>
            <div className={style['package-dropdown']}>
              <PackageDropdownContainer fulfillmentPlanId={fulfillmentPlanId} />
              <MultiPackage fulfillmentPlanId={fulfillmentPlanId} />
            </div>
          </LabeledRow>
          <LabeledRow label={<FormattedMessage {...messages.size} />} labelClassName={style.label}>
            <DimensionsContainer />
          </LabeledRow>
          {showPackageContentDescription && (
            <LabeledRow
              label={<PackageContentDescriptionLabel />}
              labelClassName={classnames(style.label, style['package-description-label'])}
            >
              <div className={style['package-description']}>
                <PackageContentDescriptionInput inputClassName={style['input-container']} />
                <div className={style.icon}>
                  <PackageContentDescriptionInfoIcon tooltipPosition='top' />
                </div>
              </div>
            </LabeledRow>
          )}
        </div>
      </div>
    </div>
  );
};

PackagePlanner.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
